import React, { useContext } from 'react';
import { Anchor, Box, Button, Text, ThemeContext } from 'grommet';
import { connect } from 'react-redux';
import { Edit } from 'grommet-icons';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Avatar from 'granite-admin/core/components/Avatar';
import { getAuthToken } from 'granite-admin/utils/auth-singleton';
import { setCookie } from 'granite-admin/utils/storage';
import Divider from 'granite-admin/core/components/Divider';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
import { getCookie } from 'granite-admin/utils/storage';
import * as UserDucks from 'granite-admin/accounts/ducks/user';
import * as OrganisationDucks from 'granite-admin/organisations/ducks/organisations';
const StyledBox = styled(Box)`
  &:hover {
    background: ${props => props.theme.global.colors['hover']};
    button {
      visibility: visible;
    }
  }
`;
const StyledButton = styled(Button)`
  visibility: hidden;
`;
const getUserAvatar = (name, image, size) => {
  if (Boolean(name) === false) return;
  return /*#__PURE__*/React.createElement(Box, {
    flex: "grow"
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: image ? image : null,
    width: size,
    height: size,
    round: "full"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    size: "small"
  }, !image && name.charAt(0).toUpperCase())));
};
const CompanyDrop = ({
  history,
  organisations,
  selectedOrganisation,
  userProfile,
  dispatch,
  signOut,
  showMyBoardBtn,
  backToBusiness
}) => {
  const theme = useContext(ThemeContext);
  const config = useContext(ConfigContext);
  const {
    showCreateOrganisation
  } = config ?? {};
  const switchOrganisation = organisation => {
    const currentSubdomain = window.location?.host.split('.')[0];
    if (config?.subdomainRedirectEnabled && organisation?.domain && organisation?.domain !== currentSubdomain) {
      const host = window.location.host;
      const domain = host.substring(host.indexOf('.') + 1, host.length - (window.location.port.length + (window.location.port.length ? 1 : 0)));
      setCookie('organisationData', JSON.stringify(organisation), 1, domain);
      setCookie('BAorigin', window.origin, 1, domain);
      setCookie('redirectDomain', 'yes', 1, domain);
      window.location = `${window.location.protocol}//${organisation.domain}.${domain}${window.location.port ? `:${window.location.port}` : ''}/login?access_token=${getAuthToken('authToken')}&redirectDomain=yes`;
    } else if (config.subdomainRedirectEnabled && getCookie('redirectDomain') === 'yes') {
      const URL = `${getCookie('BAorigin')}/login`;
      const host = window.location.host;
      const domain = host.substring(host.indexOf('.') + 1, host.length - (window.location.port.length + (window.location.port.length ? 1 : 0)));
      setCookie('organisationData', '', 1, domain);
      setCookie('BAorigin', '', 1, domain);
      setCookie('redirectDomain', '', 1, domain);
      window.location = URL;
    } else {
      dispatch({
        type: 'organisations/UPDATE_SELECTED_ORGANISATION',
        data: organisation
      });
      dispatch({
        type: 'accounts/sidebar/UPDATE_SIDEBAR',
        data: []
      });
      window.location.href = '/dashboard';
    }
  };

  // const canUserCreateOrg = process.env.REACT_APP_CAN_USER_CREATE_ORGANIZATION === 'true';
  const termsLink = process.env.REACT_APP_TERMS_URL;
  const privacyLink = process.env.REACT_APP_PRIVACY_URL;
  return /*#__PURE__*/React.createElement(Box, {
    background: "sidebar-drops",
    pad: {
      top: 'xsmall',
      bottom: 'medium'
    },
    width: "medium",
    flex: {
      shrink: 0
    }
  }, /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end",
    margin: {
      right: 'small'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/profile"
  }, /*#__PURE__*/React.createElement(Button, {
    tip: "Edit Profile",
    icon: /*#__PURE__*/React.createElement(Edit, {
      color: "brand",
      size: "small"
    }),
    plain: true
  }))), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    gap: "small"
  }, getUserAvatar(userProfile.firstName, userProfile.profileImage, 'xxsmall'), /*#__PURE__*/React.createElement(Text, null, userProfile.firstName + ' ' + userProfile.lastName), selectedOrganisation?.pk && /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    align: "center",
    margin: {
      horizontal: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, null, "Org Id: ", selectedOrganisation.pk), /*#__PURE__*/React.createElement(Button, {
    label: selectedOrganisation.name,
    onClick: () => userProfile.permissionsName.indexOf('organisation_write') > -1 && history.push('/company-settings'),
    primary: true,
    color: theme?.userProfileDrop?.button ?? 'text'
  }))), /*#__PURE__*/React.createElement(Box, {
    margin: {
      vertical: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Divider, {
    style: {
      width: 'auto',
      minWidth: 'auto'
    },
    margin: {
      horizontal: 'small'
    },
    color: "none",
    background: {
      color: 'border',
      opacity: 'medium'
    }
  }), organisations?.filter(org => org.pk !== selectedOrganisation.pk)?.map((org, i) => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, /*#__PURE__*/React.createElement(StyledBox, {
      margin: {
        vertical: 'xsmall'
      },
      pad: "small",
      direction: "row",
      justify: "between",
      align: "center"
    }, /*#__PURE__*/React.createElement(Box, {
      pad: {
        horizontal: 'small'
      },
      direction: "row",
      align: "center",
      gap: "medium"
    }, getUserAvatar(org.name, undefined, '25px'), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, null, org.name), /*#__PURE__*/React.createElement(Text, null, "Org Id: ", org.pk))), /*#__PURE__*/React.createElement(StyledButton, {
      primary: true,
      size: "small",
      label: /*#__PURE__*/React.createElement(Text, {
        size: "small"
      }, "Switch"),
      onClick: () => switchOrganisation(org)
    })), /*#__PURE__*/React.createElement(Divider, {
      color: "none",
      style: {
        width: 'auto',
        minWidth: 'auto'
      },
      margin: {
        horizontal: 'small'
      },
      background: {
        color: 'border',
        opacity: 'medium'
      }
    }));
  })), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    gap: "small"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "small"
  }, showMyBoardBtn && userProfile.isSystemAdmin && selectedOrganisation?.pk && /*#__PURE__*/React.createElement(Button, {
    label: "My Board",
    onClick: backToBusiness,
    primary: true,
    color: theme?.userProfileDrop?.button ?? 'text'
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Logout",
    onClick: signOut,
    primary: true,
    color: theme?.userProfileDrop?.button ?? 'text'
  })), !userProfile?.isSystemAdmin && showCreateOrganisation && /*#__PURE__*/React.createElement(Link, {
    to: "/get-started"
  }, /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    size: "small",
    color: "info",
    label: "Create Organization"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "medium"
  }, termsLink && /*#__PURE__*/React.createElement(Link, {
    onClick: () => window.open(termsLink),
    to: "#"
  }, /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    size: "small",
    color: "info",
    label: "Terms and Conditions"
  })), privacyLink && /*#__PURE__*/React.createElement(Link, {
    onClick: () => window.open(privacyLink),
    to: "#"
  }, /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    size: "small",
    color: "info",
    label: "Privacy Policy"
  })))));
};
CompanyDrop.propTypes = {
  history: PropTypes.object,
  signOut: PropTypes.func,
  dispatch: PropTypes.func,
  userProfile: PropTypes.object,
  organisations: PropTypes.array,
  userOrganisations: PropTypes.object,
  selectedOrganisation: PropTypes.object,
  showMyBoardBtn: PropTypes.bool,
  backToBusiness: PropTypes.func
};
CompanyDrop.defaultProps = {
  backToBusiness: () => {}
};
const mapStateToProps = state => ({
  userProfile: UserDucks.profile(state),
  organisations: OrganisationDucks.organisations(state),
  selectedOrganisation: OrganisationDucks.selectedOrganisation(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch: dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(CompanyDrop);